<app-page-breadcrumb [pageInfo]="{title:'Promotional Office Info'}"></app-page-breadcrumb>
<div class="m-2">
    <info-view [formData]="formData" [sourceData]="data"></info-view>
</div>